import React from 'react';
import {
  TabsProps,
  Tabs,
} from 'antd';

import {
  StyledAntdTabs,
} from './style';

const CVTabs = (props: TabsProps): JSX.Element => (
  <StyledAntdTabs {...props} />
);

CVTabs.TabPane = Tabs.TabPane;

export default CVTabs;
